/**
 * Guarda de rota por permissão dentro do portal do parceiro.
 *
 * O menu já esconde os itens que o usuário não pode ver, mas esconder link não é
 * proteger rota: quem digita `/portal/financeiro` na barra de endereço abre a
 * página assim mesmo. A API nega (403), então não vaza dado — o que sobra é uma
 * tela quebrada com erro que não explica nada ao funcionário.
 *
 * Aqui ele volta para o Início, que é o que ele sempre pode ver (PR 5 — o
 * Início não é tela desligável, ao contrário do antigo pouso no Dashboard).
 *
 * Isto NÃO substitui a checagem no servidor: é conveniência de navegação. Quem
 * decide o que sai no JSON é o backend.
 */
import React from "react";
import { Navigate } from "react-router-dom";

import usePortalPermissions from "@/hooks/usePortalPermissions";

interface RotaComPermissaoProps {
  /** Permissão exigida, ex.: "portal:financeiro:view" */
  permissao: string;
  children: React.ReactElement;
}

export const RotaComPermissao: React.FC<RotaComPermissaoProps> = ({ permissao, children }) => {
  const { has } = usePortalPermissions();

  if (!has(permissao)) {
    return <Navigate to="/portal/inicio" replace />;
  }

  return children;
};

export default RotaComPermissao;
